export { TableResizeHandle, TableResizeHandleProps } from './TableResizeHandle';
